<template>
  <div class="mt-4" style="min-width: 350px; border: 1px solid #4c4b48">
    <v-row class="fill-height justify-center">
      <v-col>
        <v-list id="filters-list" dense>
          <v-list-item v-if="filters.image_age_category"
            ><span class="pr-3 text--secondary">{{
              "Image Age Categories: "
            }}</span>
            {{
              uppercaseArray(filters.image_age_category).join(", ")
            }}</v-list-item
          >

          <v-list-item
            v-if="filters.query['platform'] && filters.query['platform']['in']"
            ><span class="pr-3 text--secondary">{{ "Sensors: " }}</span>
            {{
              uppercaseArray(filters.query["platform"]["in"]).join(", ")
            }}</v-list-item
          >

          <v-list-item v-if="filters.ids"
            ><span class="pr-3 text--secondary">{{
              "Acquisition ID(s): "
            }}</span>
            {{ uppercaseArray(filters.ids).join(", ") }}</v-list-item
          >

          <v-list-item id="stack-depth-info" v-if="filters.stack_depth"
            ><span class="pr-3 text--secondary">{{ "Stack Depth: " }}</span
            >{{ filters.stack_depth }}</v-list-item
          >

          <v-list-item v-if="filters.query['aoi:cloud_free_percentage']"
            ><span class="pr-3 text--secondary">{{
              "Minimum AOI Data Percentage: "
            }}</span
            >{{
              parseQueryParam(filters.query["aoi:cloud_free_percentage"])
            }}</v-list-item
          >

          <v-list-item v-if="filters.query.off_nadir_max"
            ><span class="pr-3 text--secondary">{{
              "Maximum Off Nadir Angle: "
            }}</span
            >{{ filters.query.off_nadir_max }}</v-list-item
          >

          <v-list-item v-if="is_internal && hasP3drSupport"
            ><span class="pr-3 text--secondary">{{ "P3DR Support:" }}</span
            >{{ hasP3drSupport }}</v-list-item
          >

          <v-list-item v-if="filters.query.pan_resolution_avg"
            ><span class="pr-3 text--secondary">{{ "HD Support:" }}</span
            >true</v-list-item
          >

          <v-list-item v-if="filters.query['view:sun_elevation']"
            ><span class="pr-3 text--secondary">{{ "Sun Elevation: " }}</span
            >{{
              parseQueryParam(filters.query["view:sun_elevation"])
            }}</v-list-item
          >

          <v-list-item v-if="filters.query['tile:cloud_percentage']"
            ><span class="pr-3 text--secondary">{{
              "Tile Cloud Cover Percentage: "
            }}</span
            >{{
              parseQueryParam(filters.query["tile:cloud_percentage"])
            }}</v-list-item
          >

          <v-list-item v-if="filters.query['tile:data_percentage']"
            ><span class="pr-3 text--secondary">{{
              "Tile Data Percentage: "
            }}</span
            >{{
              parseQueryParam(filters.query["tile:data_percentage"])
            }}</v-list-item
          >

          <v-list-item v-if="filters.query['view:off_nadir']"
            ><span class="pr-3 text--secondary">{{ "Off Nadir: " }}</span
            >{{ parseQueryParam(filters.query["view:off_nadir"]) }}</v-list-item
          >

          <v-list-item
            v-if="
              filters.query['collect_month'] &&
              filters.query['collect_month']['in']
            "
            ><span class="pr-3 text--secondary">{{ "Collect Months: " }}</span>
            {{
              uppercaseArray(
                convertMonthNumberArrayToTextArray(
                  filters.query["collect_month"]["in"]
                )
              ).join(", ")
            }}</v-list-item
          >

          <v-list-item
            v-if="
              filters.query['collect_month_day'] &&
              filters.query['collect_month_day']['between']
            "
            ><span class="pr-3 text--secondary">{{
              "Collect In Between: "
            }}</span>
            {{
              collectBetweenMonthDayToText(
                filters.query["collect_month_day"]["between"]
              )
            }}</v-list-item
          >

          <v-list-item
            v-if="
              filters.query['collect_day'] &&
              filters.query['collect_day']['between']
            "
            ><span class="pr-3 text--secondary">{{
              "Collect In Between Days: "
            }}</span>
            {{
              collectBetweenDaysToText(filters.query["collect_day"]["between"])
            }}</v-list-item
          >

          <v-list-item
            v-if="
              filters.query['collect_month_day'] &&
              filters.query['collect_month_day']['or']
            "
            ><span class="pr-3 text--secondary">{{ "Collect: " }}</span>
            {{
              collectOutsideMonthDayToText(
                filters.query["collect_month_day"]["or"]
              )
            }}</v-list-item
          >

          <v-list-item v-if="startDate && endDate"
            ><span class="pr-3 text--secondary"
              >{{
                isYear(startDate) && isYear(endDate)
                  ? parseInt(startDate) === parseInt(endDate)
                    ? "On Year"
                    : "Between Years"
                  : "Between"
              }}:&nbsp;</span
            >{{
              isYear(startDate) && isYear(endDate)
                ? parseInt(startDate) === parseInt(endDate)
                  ? startDate
                  : `${startDate} & ${endDate}`
                : `${stringToDate(
                    startDate
                  ).toLocaleDateString()} & ${stringToDate(
                    endDate
                  ).toLocaleDateString()}`
            }}</v-list-item
          >
          <v-list-item v-else-if="startDate"
            ><span class="pr-3 text--secondary"
              >{{
                isYear(startDate) ? "After Year" : "Start Date"
              }}:&nbsp;</span
            >{{
              isYear(startDate)
                ? startDate
                : stringToDate(startDate).toLocaleDateString()
            }}</v-list-item
          >
          <v-list-item v-else-if="endDate">
            <span class="pr-3 text--secondary"
              >{{ isYear(endDate) ? "Before Year" : "End Date" }}:&nbsp;</span
            >{{
              isYear(endDate)
                ? endDate
                : stringToDate(endDate).toLocaleDateString()
            }}</v-list-item
          >
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  props: ["filters"],
  components: {},
  computed: {
    ...mapGetters(["account_details"]),
    is_internal() {
      if (this.account_details) {
        return this.account_details.internal;
      }
      return false;
    },
    startDate() {
      const date = _.get(this.filters, "datetime", "");
      if (date.includes("/") && date.split("/")[0] != "..") {
        return date.split("/")[0];
      }
      return null;
    },
    endDate() {
      const date = _.get(this.filters, "datetime", "");
      if (date.includes("/") && date.split("/")[1] != "..") {
        return date.split("/")[1];
      }
      return null;
    },
    hasP3drSupport() {
      const hasSupport = _.get(this.filters, "query.p3dr_support.eq", null);
      return hasSupport;
    },
  },
  methods: {
    // use moment instead of Date to convert the date string to a date because of this: https://stackoverflow.com/questions/7556591/is-the-javascript-date-object-always-one-day-off
    stringToDate(strDate) {
      return moment(strDate).toDate();
    },
    isYear(value) {
      /* need null check since Number(null) = 0 */
      return value !== null && !isNaN(Number(value));
    },
    parseQueryParam(param) {
      const param_entries = Object.entries(param);
      const key = param_entries[0][0];
      const value = param_entries[0][1];

      const formattedKey = this.formatKey(key);

      return `${formattedKey} ${value}`;
    },

    formatKey(key) {
      switch (key) {
        case "gte":
          return ">=";
        case "gt":
          return ">";
        case "lte":
          return "<=";
        case "lt":
          return "<";
        case "eq":
          return "=";
        default:
          return key;
      }
    },

    collectBetweenDaysToText(between) {
      if (Array.isArray(between) && between.length > 0) {
        const startDay = this.getDaySuffix(parseInt(between[0]));
        const endDay = this.getDaySuffix(parseInt(between[1]));
        return `${startDay} - ${endDay}`;
      } else {
        const day = this.getDaySuffix(parseInt(between));
        return `${day} - ${day}`;
      }
    },

    collectBetweenMonthDayToText(between) {
      const startDate = between[0];
      const endDate = between[1];

      const startMonth = this.getMonth(startDate.split("/")[0]);
      const startDay = this.getDaySuffix(startDate.split("/")[1]);

      const endMonth = this.getMonth(endDate.split("/")[0]);
      const endDay = this.getDaySuffix(endDate.split("/")[1]);

      return `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
    },

    collectOutsideMonthDayToText(or) {
      let result = "";
      try {
        const gt = or.find((item) => {
          if (item["gt"]) {
            return item;
          }
        });
        const lt = or.find((item) => {
          if (item["lt"]) {
            return item;
          }
        });

        let beforeStr;
        if (lt) {
          const firstDate = lt.lt.split("-");
          const firstMonth = this.getMonth(firstDate[0]);
          const firstDay = this.getDaySuffix(firstDate[1]);
          beforeStr = `Before ${firstMonth} ${firstDay}`;
        }

        let afterStr;
        if (gt) {
          const secondDate = gt.gt.split("-");
          const secondMonth = this.getMonth(secondDate[0]);
          const secondDay = this.getDaySuffix(secondDate[1]);
          afterStr = `After ${secondMonth} ${secondDay}`;
        }

        if (beforeStr && afterStr) {
          result = `${beforeStr} & ${afterStr}`;
        } else if (beforeStr) {
          result = beforeStr;
        } else {
          result = afterStr;
        }
      } catch (err) {
        console.error(err);
      }

      return result;
    },

    getDaySuffix(i) {
      var j = i % 10,
        k = i % 100;
      if (j == 1 && k != 11) {
        return i + "st";
      }
      if (j == 2 && k != 12) {
        return i + "nd";
      }
      if (j == 3 && k != 13) {
        return i + "rd";
      }
      return i + "th";
    },

    convertMonthNumberArrayToTextArray(array) {
      const result = [];
      if (array && array.length > 0) {
        array.forEach((monthNumber) => {
          result.push(this.getMonth(monthNumber));
        }, this);
      }

      return result;
    },

    getMonth(number) {
      const month = parseInt(number);
      switch (month) {
        case 1:
          return "January";
        case 2:
          return "February";
        case 3:
          return "March";
        case 4:
          return "April";
        case 5:
          return "May";
        case 6:
          return "June";
        case 7:
          return "July";
        case 8:
          return "August";
        case 9:
          return "September";
        case 10:
          return "October";
        case 11:
          return "November";
        case 12:
          return "December";
      }

      return number;
    },

    uppercaseArray(stringArray) {
      return stringArray.map((string) => {
        return string[0].toUpperCase() + string.substring(1);
      });
    },
  },
};
</script>
